<template>
  <div>
    <ValidationProvider
      v-slot="{ errors }"
      ref="aiAssistantValidationProviderRef"
      name="aiAssistant"
      rules="required">
      <b-form-group>
        <label
          for="p-key"
          class="settings__label flex flex-align-center" >
          Select
        </label>
        <div
          v-if="!aiMembers.length"
          class="skeleton" />
        <div
          v-else
          id="attachment-wrapper">
          <multiselect
            v-model="aiAgent"
            placeholder="Select an option"
            class="flex-options hide-tags no-selected-background"
            :options="aiMembers"
            label="name"
            track-by="id"
            :multiple="false"
            :show-labels="false"
            :show-no-results="false"
            :clear-on-select="false"
            :preserve-search="true"
            :allow-empty="false"
            :preselect-first="true"
            :searchable="false" >
            <template
              slot="singleLabel"
              slot-scope="props" >
              <div class="flex flex-align-center">
                <span
                  class="avatar no-shrink"
                  :style="{ backgroundImage: `url(${props.option.avatar})` }"
                />
                <p class="ellipsis">{{ props.option.name }}</p>
              </div>
            </template>
            <template
              slot="option"
              slot-scope="props">
              <span
                class="avatar no-shrink"
                :style="{ backgroundImage: `url(${props.option.avatar})` }"
              />
              <p>{{ props.option.name }}</p>
              <SBIcon
                :icon="SBIconList.DONE_TICK"
                :color="SBColors.bluePrimary"
                :size="9"
                class="mr-0" />
            </template>
          </multiselect>
        </div>
        <div
          v-if="errors[0]"
          class="error flex flex-align-center">
          <SBIcon
            class="mr-2"
            :icon="SBIconList.ERROR"
            :color="SBColors.redPrimary"
            :size="12" />
          <span>{{ errors[0] }}</span>
        </div>
      </b-form-group>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Multiselect from 'vue-multiselect';

import SBIconList from '@/helpers/lists/sb-icon-list';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import { memberTypes } from '@/helpers/enums/memberTypes.enum';
import api from '@/helpers/api';

export default {
  name: 'AiAssistantBlock',
  components: {
    SBIcon,
    Multiselect,
  },
  props: {
    node: {
      type: Object,
      required: false,
      default: () => {},
    },
    editMode: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      aiAgent: null,
      SBIconList,
      SBColors,
      memberTypes,
      aiMembers: [],
    };
  },
  computed: {
    ...mapGetters({
      organisationMembers2: 'organisation/organisationMembers2',
      flowsDefinitions: 'flows/flowsDefinitions',
    }),
  },
  beforeMount() {
    const targetTypeDefinition = this.flowsDefinitions.blocks.definitions.actions.find(l => l.meta.type === 'ASSAITOCONV');
    api(targetTypeDefinition.definition.callable_endpoint.method, targetTypeDefinition.definition.callable_endpoint.url, { noPrefix: true }, null, 'w')
      .then((response) => {
        if (response.status === 200) {
          this.aiMembers = response.data;
          if (this.node && this.editMode) {
            this.aiAgent = this.aiMembers.find(
              member => member.id === this.node.blockData.params.user_uid,
            );
          }
        } else {}
      })
      .catch(() => {});
  },
  methods: {
    ...mapActions({
      addFlowBlock: 'flows/addFlowBlock',
      editFlowBlock: 'flows/editFlowBlock',
    }),
    submit(parentId) {
      if (
        this.$refs.aiAssistantValidationProviderRef.validate()
      ) {
        if (!this.editMode) {
          this.addFlowBlock({
            parentId,
            block: {
              category: 'actions',
              type: 'ASSAITOCONV',
              params: {
                respond_upon_assignment: true,
                user_uid: this.aiAgent.id,
              },
            },
          })
            .then((response) => {
              if (response.status === 200) {
                this.$emit('finished');
              }
            });
        } else {
          this.editFlowBlock({
            blockId: this.node.id,
            block: {
              category: 'actions',
              type: 'ASSAITOCONV',
              params: {
                respond_upon_assignment: true,
                user_uid: this.aiAgent.id,
              },
            },
          })
            .then((response) => {
              if (response.status === 200) {
                this.$emit('finished');
              }
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #f5f5f5;
  margin-right: 10px;
  display: inline-block;
}

::v-deep .multiselect.no-selected-background .multiselect__content-wrapper .multiselect__content .multiselect__element .multiselect__option.multiselect__option--selected {
  color: $blackPrimary !important;
}

.skeleton {
  border: 1px solid #CFD8DC;
  border-radius: 5px;
  box-shadow: 0 1px 3px 0 rgba(48, 54, 70, 0.15);
  background: $white;
  height: 32px;
  padding: 8px;

  &::before {
    content: '';
    display: inline-block;
    width: 15px;
    height: 15px;
    background: #edf0f2;
    border-radius: 6px;
  }

  &::after {
    content: '';
    display: inline-block;
    width: 60%;
    height: 15px;
    background: #edf0f2;
    border-radius: 6px;
    margin-left: 8px;
  }
}
</style>
